export function fmtUGX(n: number): string {
  return "USD " + new Intl.NumberFormat("en-ZW").format(Math.round(n || 0));
}

export function fmtUSD(n: number): string {
  return "USD " + new Intl.NumberFormat("en-ZW").format(Math.round(n || 0));
}

export function fmtZiG(n: number): string {
  return "ZiG " + new Intl.NumberFormat("en-ZW").format(Math.round(n || 0));
}

export function fmtCurrency(n: number, currency: "USD" | "ZiG" = "USD"): string {
  const prefix = currency === "ZiG" ? "ZiG " : "USD ";
  return prefix + new Intl.NumberFormat("en-ZW").format(Math.round(n || 0));
}

export function fmtNum(n: number): string {
  return new Intl.NumberFormat("en-ZW").format(n || 0);
}

export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}

export function shortDateTime(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const diff = (now.getTime() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
